import { render, staticRenderFns } from "./input-form.vue?vue&type=template&id=b074e004&"
import script from "./input-form.vue?vue&type=script&lang=js&"
export * from "./input-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports